<template>
  <nav class="MenuPane" :class="{ isShowing }">
    <slot />
  </nav>
</template>

<script>
export default {
  props: {
    isShowing: {
      type: Boolean,
      required: true,
    },
  },
}
</script>

<style scoped>

.MenuPane {
  position: absolute;
  top: 0;
  left: 100%;
  width: 100%;
  height: 100%;
  transition: left var(--menu-transition-time);
  overflow-x: hidden;
  overflow-y: auto;
}

.MenuPane.isShowing {
  left: 0;
}
</style>
